import adminPanelWelcomeSlice from "./containers/AdminPanelPages/WelcomePage/reducer";
import { combineReducers, configureStore, createImmutableStateInvariantMiddleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import configureApi from "./api";
import configureAuth from "./auth";

import globalSlice from "./containers/App/reducer";
import authModalSlice from "./containers/AuthModal/reducer";
import homeSlice from "./containers/HomePage/reducer";

import clientProfileSlice from "./containers/PersonalAreaPages/ProfilePages/containers/ClientProfilePage/reducer";
import backOfficeProfileSlice from "./containers/PersonalAreaPages/ProfilePages/containers/BackOfficeProfilePage/reducer";
import securitySlice from "./containers/PersonalAreaPages/ProfilePages/containers/SecurityPage/reducer";

import clientDocumentsSlice from "./containers/PersonalAreaPages/DocumentsPages/containers/ClientDocumentsPage/reducer";

import companyDetailsSlice from "./containers/PersonalAreaPages/CompanyDetailsPage/reducer";

import dictionariesCoefficentsSlice from "./containers/PersonalAreaPages/DictionariesCoefficentsPage/reducer";
import dictionariesCountriesSlice from "./containers/PersonalAreaPages/DictionariesCountriesPage/reducer";
import dictionariesCurrenciesSlice from "./containers/PersonalAreaPages/DictionariesCurrenciesPage/reducer";
import dictionariesLocationsSlice from "./containers/PersonalAreaPages/DictionariesLocationsPage/reducer";
import dictionariesRoutesSlice from "./containers/PersonalAreaPages/DictionariesRoutesPage/reducer";
import dictionariesUsersSlice from "./containers/PersonalAreaPages/DictionariesUsersPage/reducer";
import dictionariesCompaniesSlice from "./containers/PersonalAreaPages/DictionariesCompaniesPage/reducer";
import dictionariesRatesUpdateSlice from "./containers/PersonalAreaPages/DictionariesRatesUpdatePage/reducer";

import auditLogSlice from "./containers/PersonalAreaPages/AuditLogPage/reducer";
import operdayErrorsSlice from "./containers/PersonalAreaPages/OperdayErrorsPage/reducer";

import notificationsSlice from "./layouts/PersonalAreaLayout/reducer";

import globalSaga from "./containers/App/sagas";
import importRoutesSlice from "./containers/PersonalAreaPages/DictionariesRoutesPage/components/ImportRoutesPage/reducer";
import dictionariesRateUpdateRoutesSlice from "./containers/PersonalAreaPages/DictionariesRateUpdateRoutes/reducer";
import dictionariesApplicationServicesSlice from "./containers/PersonalAreaPages/DictionariesApplicationServicesPage/reducer";

import quoteAutofillLabSlice from "./containers/QuoteAutofillLab/reducer";
import applicationSlice from "./containers/ApplicationPage/reducer";
import statisticsSlice from "./containers/PersonalAreaPages/StatisticsPage/reducer";
import rateUsageAnalyticsSlice from "./containers/PersonalAreaPages/RateUsageAnalyticsPage/reducer";
import applicationCoefficientsSlice from "./containers/PersonalAreaPages/ApplicationCoefficentsPage/reducer";
import bitrixCompanyUsageSlice from "./containers/PersonalAreaPages/BitrixCompanyUsagePage/reducer";
import translationsSlice from "./containers/TranslationsPage/reducer";
import commercialOfferSlice from "./containers/CommercialOfferPage/reducer";
import commercialOffersSlice from "./containers/CommercialOffersPage/reducer";
import dealsSlice from "./containers/DealsPage/reducer";
import dealsTrackingReportSlice from "./containers/DealsTrackingReportPage/reducer";
import dealSlice from "./containers/DealPage/reducer";
import carrierReviewsSlice from "./components/CarrierReviews/reducer";
import accountantPaymentsSlice from "./containers/AccountantPages/PaymentsPage/reducer";
import accountantAccountsSlice from "./containers/AccountantPages/AccountsPage/reducer";
import accountantAcountClosingDocumentsSlice from "./containers/AccountantPages/AccountClosingDocumentsPage/reducer";
import applicationsSlice from "./containers/ApplicationsPage/reducer";
import accountantBonusesSlice from "./containers/AccountantPages/BonusesPage/reducer";
import settlementAccountsSlice from "./containers/PersonalAreaPages/SettlementAccountsPage/reducer";
import specialDealsSlice from "./widgets/SpecialDeals/reducer";
import cashReimbursementsSlice from "./widgets/CashReimbursements/reducer";
import specialFinanceSlice from "./widgets/SpecialFinance/reducer";
import adminPanelSlice from "./layouts/AdminPanelLayout/reducer";
import adminPanelReportsSlice from "./containers/AdminPanelPages/ReportsPage/reducer";
import adminPanelSalesReportsSlice from "./containers/AdminPanelPages/SalesReportsPage/reducer";
import adminPanelApplicationsSlice from "./containers/AdminPanelPages/ApplicationsPage/reducer";
import adminPanelDealsSlice from "./containers/AdminPanelPages/DealsPage/reducer";
import adminPanelApplicationSlice from "./containers/AdminPanelPages/ApplicationPage/reducer";
import adminPanelDealSlice from "./containers/AdminPanelPages/DealPage/reducer";
import adminPanelAiMonitoringSlice from "./containers/AdminPanelPages/AiMonitoringPage/reducer";
import adminPanelFinancialMonitorSlice from "./containers/AdminPanelPages/FinancialMonitorPage/reducer";
import adminPanelTrackingReportSlice from "./containers/AdminPanelPages/TrackingReportPage/reducer";
import expenseCategoryServicesSlice from "./containers/PersonalAreaPages/ExpenseCategoryServicePage/reducer";
import contractorsSlice from "./containers/ContractorsPage/reducer";
import overheadExpenseSlice from "./containers/AccountantPages/OverheadExpensesPage/reducer";
import regionsSlice from "./containers/PersonalAreaPages/RegionsPage/reducer";
import createApplicationModalSlice from "./widgets/CreateApplicationModal/reducer";
import leadsSlice from "./containers/LeadsPage/reducer";
import createLeadModalSlice from "./widgets/CreateLeadModal/reducer";
import leadSlice from "./containers/LeadPage/reducer";
import createMessageModalSlice from "./widgets/CreateMessageModal/reducer";
import dealNotificationModalSlice from "./widgets/DealNotificationModal/reducer";
import editContractorDrawer from "./widgets/EditContractorDrawer/reducer";
import paymentRequestsSlice from "./containers/PaymentRequestsPage/reducer";
import paymentTypesSlice from "./containers/PersonalAreaPages/PaymentTypesPage/reducer";
import rateHistoryModalSlice from "./widgets/RateHistoryModal/reducer";
import businessHistorySlice from "./widgets/BusinessHistory/reducer";

export const sagaMiddleware = createSagaMiddleware();

export const initialReducer = {
  [adminPanelWelcomeSlice.name]: adminPanelWelcomeSlice.reducer,
  [globalSlice.name]: globalSlice.reducer,
  [authModalSlice.name]: authModalSlice.reducer,
  [homeSlice.name]: homeSlice.reducer,

  [clientProfileSlice.name]: clientProfileSlice.reducer,
  [backOfficeProfileSlice.name]: backOfficeProfileSlice.reducer,
  [securitySlice.name]: securitySlice.reducer,

  [clientDocumentsSlice.name]: clientDocumentsSlice.reducer,

  [companyDetailsSlice.name]: companyDetailsSlice.reducer,
  [auditLogSlice.name]: auditLogSlice.reducer,
  [operdayErrorsSlice.name]: operdayErrorsSlice.reducer,
  [statisticsSlice.name]: statisticsSlice.reducer,
  [rateUsageAnalyticsSlice.name]: rateUsageAnalyticsSlice.reducer,

  [dictionariesCoefficentsSlice.name]: dictionariesCoefficentsSlice.reducer,
  [dictionariesCountriesSlice.name]: dictionariesCountriesSlice.reducer,
  [dictionariesCurrenciesSlice.name]: dictionariesCurrenciesSlice.reducer,
  [dictionariesLocationsSlice.name]: dictionariesLocationsSlice.reducer,
  [dictionariesRatesUpdateSlice.name]: dictionariesRatesUpdateSlice.reducer,
  [dictionariesRateUpdateRoutesSlice.name]: dictionariesRateUpdateRoutesSlice.reducer,
  [dictionariesRoutesSlice.name]: dictionariesRoutesSlice.reducer,
  [dictionariesUsersSlice.name]: dictionariesUsersSlice.reducer,
  [dictionariesCompaniesSlice.name]: dictionariesCompaniesSlice.reducer,
  [dictionariesApplicationServicesSlice.name]: dictionariesApplicationServicesSlice.reducer,

  [importRoutesSlice.name]: importRoutesSlice.reducer,

  [notificationsSlice.name]: notificationsSlice.reducer,

  [applicationSlice.name]: applicationSlice.reducer,
  [quoteAutofillLabSlice.name]: quoteAutofillLabSlice.reducer,
  [commercialOfferSlice.name]: commercialOfferSlice.reducer,

  [applicationCoefficientsSlice.name]: applicationCoefficientsSlice.reducer,
  [bitrixCompanyUsageSlice.name]: bitrixCompanyUsageSlice.reducer,

  [translationsSlice.name]: translationsSlice.reducer,

  [applicationsSlice.name]: applicationsSlice.reducer,

  [commercialOffersSlice.name]: commercialOffersSlice.reducer,

  [dealsSlice.name]: dealsSlice.reducer,
  [dealsTrackingReportSlice.name]: dealsTrackingReportSlice.reducer,
  [dealSlice.name]: dealSlice.reducer,
  [carrierReviewsSlice.name]: carrierReviewsSlice.reducer,

  [accountantPaymentsSlice.name]: accountantPaymentsSlice.reducer,
  [accountantAccountsSlice.name]: accountantAccountsSlice.reducer,
  [accountantAcountClosingDocumentsSlice.name]: accountantAcountClosingDocumentsSlice.reducer,
  [accountantBonusesSlice.name]: accountantBonusesSlice.reducer,

  [settlementAccountsSlice.name]: settlementAccountsSlice.reducer,
  [specialDealsSlice.name]: specialDealsSlice.reducer,
  [cashReimbursementsSlice.name]: cashReimbursementsSlice.reducer,
  [specialFinanceSlice.name]: specialFinanceSlice.reducer,

  [adminPanelSlice.name]: adminPanelSlice.reducer,
  [adminPanelReportsSlice.name]: adminPanelReportsSlice.reducer,
  [adminPanelSalesReportsSlice.name]: adminPanelSalesReportsSlice.reducer,
  [adminPanelApplicationsSlice.name]: adminPanelApplicationsSlice.reducer,
  [adminPanelDealsSlice.name]: adminPanelDealsSlice.reducer,
  [adminPanelDealSlice.name]: adminPanelDealSlice.reducer,
  [adminPanelApplicationSlice.name]: adminPanelApplicationSlice.reducer,
  [adminPanelAiMonitoringSlice.name]: adminPanelAiMonitoringSlice.reducer,
  [adminPanelFinancialMonitorSlice.name]: adminPanelFinancialMonitorSlice.reducer,
  [adminPanelTrackingReportSlice.name]: adminPanelTrackingReportSlice.reducer,

  [expenseCategoryServicesSlice.name]: expenseCategoryServicesSlice.reducer,
  [contractorsSlice.name]: contractorsSlice.reducer,
  [overheadExpenseSlice.name]: overheadExpenseSlice.reducer,
  [paymentRequestsSlice.name]: paymentRequestsSlice.reducer,
  [paymentTypesSlice.name]: paymentTypesSlice.reducer,

  [regionsSlice.name]: regionsSlice.reducer,

  [createApplicationModalSlice.name]: createApplicationModalSlice.reducer,
  [createLeadModalSlice.name]: createLeadModalSlice.reducer,
  [createMessageModalSlice.name]: createMessageModalSlice.reducer,
  [dealNotificationModalSlice.name]: dealNotificationModalSlice.reducer,
  [rateHistoryModalSlice.name]: rateHistoryModalSlice.reducer,
  [businessHistorySlice.name]: businessHistorySlice.reducer,

  [leadsSlice.name]: leadsSlice.reducer,
  [leadSlice.name]: leadSlice.reducer,

  [editContractorDrawer.name]: editContractorDrawer.reducer,
};

const reducer = combineReducers(initialReducer);

const immutableInvariantMiddleware = createImmutableStateInvariantMiddleware();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: false,
    }).concat(sagaMiddleware, immutableInvariantMiddleware),
});

configureApi(sagaMiddleware);
configureAuth(sagaMiddleware);

sagaMiddleware.run(globalSaga as any);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
